import jwt_decode from "jwt-decode";
import { logout } from "../../helpers/utils";

export function useProvideAuth() {  
  const token = window.localStorage.getItem('eventsafeguardtoken');
  if (token) {
    let decoded = {};
    try {
      decoded = jwt_decode(token);
    } catch (e) {
      logout();
      return { user: null, isAdmin: false };
    }

    // If token has expired, trigger logout and return null user
    if (decoded && decoded.exp && Date.now() >= decoded.exp * 1000) {
      logout();
      return { user: null, isAdmin: false };
    }

    const storedRoleId = window.localStorage.getItem('roleId');
    const storedIsAdmin = window.localStorage.getItem('isAdmin');
    const roleId = decoded.roleId || storedRoleId || (decoded.isSupplier ? null : 1);
    const isAdmin = decoded.isAdmin === true || roleId == 1 || storedIsAdmin === "true";

    const user = {
      user: window.localStorage.getItem('user'),
      fullname: window.localStorage.getItem('fullname'),
      companyName: window.localStorage.getItem('companyname'),
      companyUniqueKey: window.localStorage.getItem('companyUniqueKey'),
      token: token,
      roleId: roleId ? Number(roleId) : null,
      isAdmin: isAdmin,
      isSupplier: Boolean(decoded.isSupplier)
    };
    return user;
  } else {
    return { user: null, isAdmin: false };
  }
}
